import { ReactElement } from 'react';

interface TpVerticalSplitterProps {
  left: ReactElement;
  right: ReactElement | null;
}

// @todo: make the splitter position draggable
function VerticalSplitter({ left, right }: TpVerticalSplitterProps) {
  if (!right) return left;
  const hSplitterWidth = 3;
  const frac = 0.5;
  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div
        style={{
          height: '100%',
          width: `calc(${frac * 100}% - ${hSplitterWidth}px)`,
          display: 'inline-block',
          verticalAlign: 'top',
        }}
      >
        {left}
      </div>
      <div
        style={{
          height: '100%',
          width: `${2 * hSplitterWidth}px`,
          background: 'rgba(128,128,128,0.5)',
          display: 'inline-block',
          verticalAlign: 'top',
        }}
      />
      <div
        style={{
          height: '100%',
          width: `calc(${(1 - frac) * 100}% - ${hSplitterWidth}px)`,
          display: 'inline-block',
          verticalAlign: 'top',
        }}
      >
        {right}
      </div>
    </div>
  );
}

export default VerticalSplitter;
